import * as Yup from 'yup'
import {
  BUDGET_DAILY,
  BUDGET_LIFETIME,
  CAMPAIGN_BUDGET,
  CATEGORY_CREDIT,
  CATEGORY_EMPLOYMENT,
  CATEGORY_HOUSING,
  DO_NOT_ASK_CATEGORY,
  NAME,
  NO_BUDGET,
  SPECIAL_AD_CATEGORIES,
  STATUS,
  STATUS_ACTIVE
} from '../../../../Multiplatform/CampaignForms/fields'
import {
  APP_INSTALLS,
  AUTOMATIC,
  CONVERSIONS,
  LEAD_GENERATION,
  LINK_CLICKS,
  MESSAGES,
  OUTCOME_AWARENESS,
  OUTCOME_ENGAGEMENT,
  OUTCOME_SALES,
  OUTCOME_TRAFFIC,
  POST_ENGAGEMENT,
  PRODUCT_CATALOG_SALES,
  STORE_VISITS,
  VIDEO_VIEWS
} from '../../../../../constants/campaigns'
import nameValidation from '../../../../../features/validations/name'
import { OBJECTIVE } from '../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/fields'
import { OPTION_NO } from '../../../../../constants/forms'

// BUYING TYPE
export const BUYING_TYPE = 'buying_type'
// BUYING TYPE OPTIONS
export const BUYING_TYPE_AUCTION = 'auction'
export const BUYING_TYPE_RESERVED = 'reserved'

// GOAL
export const OPTIMISE_OBJECTIVE = 'objective'

// BIDDING TYPE
export const BIDDING_TYPE = 'bidding_type'

export const initialValues = {
  [NAME]: '',
  [BIDDING_TYPE]: AUTOMATIC,
  [BUYING_TYPE]: BUYING_TYPE_AUCTION,
  [OPTIMISE_OBJECTIVE]: OUTCOME_AWARENESS,
  // budget
  [CAMPAIGN_BUDGET]: BUDGET_LIFETIME,
  [BUDGET_LIFETIME]: '',
  [BUDGET_DAILY]: '',
  // special ad categories
  [SPECIAL_AD_CATEGORIES]: OPTION_NO,
  [CATEGORY_CREDIT]: false,
  [CATEGORY_EMPLOYMENT]: false,
  [CATEGORY_HOUSING]: false,
  [DO_NOT_ASK_CATEGORY]: false,
  // status
  [STATUS]: STATUS_ACTIVE
}

export const validationSchema = Yup.object({
  ...nameValidation,
  [BUDGET_LIFETIME]: Yup.string().when(CAMPAIGN_BUDGET, {
    is: BUDGET_LIFETIME,
    then: () => Yup.string().required('Budget Required')
  }),
  [BUDGET_DAILY]: Yup.string().when(CAMPAIGN_BUDGET, {
    is: BUDGET_DAILY,
    then: () => Yup.string().required('Budget Required')
  })
})

// constants for BIDDING_TYPE step
export const costCapObjectiveValues = [
  APP_INSTALLS,
  CONVERSIONS,
  OUTCOME_SALES,
  LEAD_GENERATION,
  LINK_CLICKS,
  OUTCOME_TRAFFIC,
  POST_ENGAGEMENT,
  OUTCOME_ENGAGEMENT,
  VIDEO_VIEWS,
  PRODUCT_CATALOG_SALES,
  MESSAGES
]

export const minimumRoasObjectiveValues = [APP_INSTALLS, CONVERSIONS, PRODUCT_CATALOG_SALES]

export const manualObjectiveValues = [STORE_VISITS, MESSAGES]

// export const capRelatedValues = [...costCapObjectiveValues, STORE_VISITS]

export const checkIsValueRelated = (selectedValue, values) => {
  const isValueRelated = values.find(value => value === selectedValue)

  return !!isValueRelated
}

export const transformValuesToBE = (values, selectedAdAccountId, savedUserSettings) => {
  const specialCategories = [CATEGORY_CREDIT, CATEGORY_EMPLOYMENT, CATEGORY_HOUSING]

  return {
    account: selectedAdAccountId,
    [NAME]: values[NAME],
    [STATUS]: values[STATUS],
    [BUYING_TYPE]: values[BUYING_TYPE],
    [OBJECTIVE]: values[OBJECTIVE],

    ...(savedUserSettings[SPECIAL_AD_CATEGORIES] !== OPTION_NO && {
      // combine separated values in one special_ad_categories array field
      [SPECIAL_AD_CATEGORIES]: specialCategories.filter(category => values[category])
    }),
    ...(values[OPTIMISE_OBJECTIVE] === OUTCOME_SALES &&
      values[CAMPAIGN_BUDGET] !== NO_BUDGET && { [BIDDING_TYPE]: values[BIDDING_TYPE] }),
    // hardcode automatic bidding_type for not conversions campaigns
    ...(values[OPTIMISE_OBJECTIVE] !== OUTCOME_SALES &&
      values[CAMPAIGN_BUDGET] !== NO_BUDGET && {
        [BIDDING_TYPE]: 'automatic'
      }),
    ...(values[CAMPAIGN_BUDGET] === 'budget_lifetime' && { budget_lifetime: values['budget_lifetime'] }),
    ...(values[CAMPAIGN_BUDGET] === 'budget_daily' && { budget_daily: values['budget_daily'] })
  }
}
